"use client";
import React from "react";
import { usePathname } from "next/navigation";
import CTAneutral from "./CTAneutral";

export default function AtfCta() {
  const pathname = usePathname();

  const ctaHiddenPages = ["/schedule-a-consultation", "/careers"];

  if (ctaHiddenPages.includes(pathname)) {
    return null;
  }

  return <CTAneutral />;
}
